import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorListSkeletonRow } from "web_myplann/Calculators/Components/CalculatorListSkeletonRow";
import type { CalculatorSection } from "web_myplann/Calculators/Types/CalculatorSection";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";
import { SabSkeleton } from "web_myplann/Shared/Skeletons";

type Props = {
	section: CalculatorSection;
};

export const CalculatorListSkeletonSection: FC<Props> = ({ section }) => {
	const theme = useTheme();

	return (
		<>
			<SectionHeader
				title={<SabSkeleton variant="text" width={120} height={16} />}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				{section.types.map((type, index) => (
					<CalculatorListSkeletonRow
						key={type}
						isLast={index === section.types.length - 1}
					/>
				))}
			</Stack>
		</>
	);
};
